import React, { Component } from "react"
import { withAuth0 } from "@auth0/auth0-react"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import Chip from "@material-ui/core/Chip"
import AccountCircle from "@material-ui/icons/AccountCircle"
import Button from "@material-ui/core/Button"
import "../styles/ComponentBase/MainAppBar.css"
import { saveOperatorCurrentActivity } from "../utils/api"
import { ACTIVITY } from "../Config"
import { getDashboardUIURL } from "../utils/env"

class MainAppBar extends Component {
  // New method to handle logout
  handleLogout = async () => {
    try {
      // Call our saveOperatorCurrentActivity method
      await saveOperatorCurrentActivity(this.props.auth0.user.email, ACTIVITY.LOG_OFF)

      // Call auth0.logout to log the user out
      this.props.auth0.logout({
        returnTo: getDashboardUIURL(),
      })
    } catch (error) {
      // Handle error if saveOperatorCurrentActivity fails
      console.error("Error during logout:", error)
    }
  }
  render() {
    return (
      <div className="root">
        <AppBar
          position="relative"
          className={document.fullscreen ? "appBarFullscreen" : "appBarNotFullscreen"}
        >
          <Toolbar variant="dense" className="toolbar">
            <Typography variant="h6" color="inherit" className="grow">
              Zippin - Operator Console
            </Typography>
            {this.props.auth0.isAuthenticated && (
              <React.Fragment>
                <Chip
                  icon={<AccountCircle />}
                  label={this.props.auth0.user.email}
                  color="primary"
                />
                <Button
                  color="inherit"
                  onClick={this.handleLogout} // Call the new method on click
                >
                  Log Out
                </Button>
              </React.Fragment>
            )}
          </Toolbar>
        </AppBar>
        {this.props.children}
      </div>
    )
  }
}

export default withAuth0(MainAppBar)
